import { action, computed, makeObservable, observable } from "mobx";
import toast from "react-hot-toast";
import URLConstants from "../../constants/url-constants";
import {
  IAddAgreement,
  IAgreementListVM,
  IGetAgreement,
} from "../../models/forms/IAgreement";
import { IObservableInitialState, IOption } from "../../models/ICommon";
import IApiResponse, {
  IApiSuccessResponse,
} from "../../models/response/IApiResponse";
import { formatMessage } from "../../translations/format-message";
import {
  agreementInitialState,
  initialAgreementValues,
} from "../initialState/add-edit-agreement-state";
import { agreementInitialFilterState } from "../initialState/initial-filter-state";
import * as baseService from "../service/base-service";
import { IUpdateAgreementPassword } from "../../models/forms/IChangePassword";
import { getBusinessTypeIdFromLocalStorage, getUserTypeFromLocalStorage } from "../../helpers/localstorage-helper";
import userTypeEnum from "../../constants/enums/user-type-enum";
import { initialStateAgreementPassword } from "../initialState/change-password-state";
import { IAgreementFilter } from "../../models/IFilter";

export class AgreementManagementStore {
  initialValues: any = {
    ...initialAgreementValues,
  };

  initialStateValue: IObservableInitialState = {
    success: false,
    error: "",
    inProgress: false,
  };
  agreement: IAddAgreement = { ...initialAgreementValues };
  agreementList: IAgreementListVM = agreementInitialState;
  agreementFilter: IAgreementFilter = { ...agreementInitialFilterState };
  addUpdateAgreementState = { ...this.initialStateValue };
  getAllAgreementListState = { ...this.initialStateValue };
  getAgreementByIdState = { ...this.initialStateValue };
  deleteAgreementState = { ...this.initialStateValue };

  changeAgreementPasswordState = { ...this.initialStateValue };
  agreementPassword: IUpdateAgreementPassword = { ...initialStateAgreementPassword }
  
  agreementOptionsState = { ...this.initialStateValue };
  allAgreements: IGetAgreement[] = []; 
  disableAction: boolean = false;

  constructor() {
    makeObservable(this, {
      initialValues: observable,
      agreement: observable,
      agreementList: observable,
      agreementFilter: observable,
      getAgreementByIdState: observable,
      getAllAgreementListState: observable,
      addUpdateAgreementState: observable,
      deleteAgreementState: observable,
      agreementPassword: observable,
      changeAgreementPasswordState: observable,

      agreementOptionsState: observable,
      allAgreements: observable,
      disableAction: observable,

      GetAllAgreementListService: action,
      UpdateAgreementService: action,
      setAgreementFilter: action,
      resetAgreementFilterDetail: action,
      deleteAgreementService: action,
      GetAgreementByIdService: action,
      GetAllAgreementOptionService: action,

      resetGetAgreementDetail: action,
      AddAgreementService: action,
      resetInitialValues: action,
      resetAgreementList: action,
      resetAddAgreement: action,
      resetagreementOptionsState: action,
      setDisableAction: action,

      resetChangePassword: action,
      getAllAgreementList: computed,
      getAgreementDetail: computed,
      getAllAgreementOptions: computed,
    });
  }

  GetAllAgreementListService = (
    currentPage: number,
    pagerSize: number,
    orderBy: string,
    column: string,
    filter: {
      businessTypeId?: number;
      showInvalid?: boolean;
      freeword?: string;
    }
  ) => {
    this.getAllAgreementListState.inProgress = true;
    const queryParams = new URLSearchParams({
      PageNo: currentPage.toString(),
      PageSize: pagerSize.toString(),
      OrderBy: orderBy,
      ColumnName: column,
    });
    if (filter.businessTypeId !== undefined) {
      queryParams.append("businessTypeid", filter.businessTypeId.toString());
    }
    if (filter.showInvalid !== undefined) {
      queryParams.append("showInvalid", filter.showInvalid.toString());
    }
    if (filter.freeword) {
      queryParams.append("freeword", filter.freeword);
    }
    const url = `${URLConstants.AgreementList}?${queryParams.toString()}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IAgreementListVM>>) => {
        if (response.data.Error) {
          this.getAllAgreementListState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.agreementList = response.data.Data;
        }
      })
      .catch((err: string) => {
        this.getAllAgreementListState.error = err;
      })
      .finally(
        action(() => {
          this.getAllAgreementListState.inProgress = false;
        })
      );
  };
  
  

  GetAllAgreementOptionService = () => {
    this.agreementOptionsState.inProgress = true;
    let userType = getUserTypeFromLocalStorage();
    let businessTypeId = getBusinessTypeIdFromLocalStorage();
    const url = `${URLConstants.GetAllAgreements}?BusinessTypeId=${(userType === userTypeEnum[userTypeEnum.HeadQuarter] || userType === userTypeEnum[userTypeEnum.Store]) ? businessTypeId : null}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IGetAgreement[]>>) => {
        if (response.data.Error) {
          this.agreementOptionsState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.agreementOptionsState.success = true;
          this.allAgreements = response.data.Data;
        }
      })
      .catch((err: string) => {
        this.agreementOptionsState.error = err;
      })
      .finally(
        action(() => {
          this.agreementOptionsState.inProgress = false;
        })
      );
  };

  /**
   * This function is used to map allTaxOptions to allGeneral List suitable for Grid Component.
   * @returns getAllTaxOptions
   */
  get getAllAgreementOptions(): IOption[] {
    const options: IOption[] = [
      {
        id:-1, value:'please_select'
      }
    ];

    if (this.allAgreements && this.allAgreements.length > 0) {
      this.allAgreements.map((agreement: IGetAgreement) => {
        options.push({
          id: agreement.Id,
          value: agreement.AgreementName,
          label: agreement.AgreementName,
          disabled: false,
          data: { ...agreement },
        });
      });
    }
    return options;
  }

  resetagreementOptionsState = () =>{
    this.agreementOptionsState = {...this.initialStateValue};
    this.allAgreements = [];
  }

  AddAgreementService = (data: IAddAgreement) => {
    this.addUpdateAgreementState.inProgress = true;
    let url = URLConstants.AddAgreement;
    let finalData: IAddAgreement = {
      ...data,
    };
    return baseService
      .postRequest(url, finalData)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.addUpdateAgreementState.error = response.data.Message;
        } else this.addUpdateAgreementState.success = true;
      })
      .catch((err: string) => {
        this.addUpdateAgreementState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateAgreementState.inProgress = false;
        })
      );
  };

  UpdateAgreementService = (data: IAddAgreement) => {
    this.addUpdateAgreementState.inProgress = true;
    let url = URLConstants.UpdateAgreement;
    let finalData: IAddAgreement = {
      ...data,
    };
    return baseService
      .putRequest(url, finalData)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.addUpdateAgreementState.error = response.data.Message;
        } else this.addUpdateAgreementState.success = true;
      })
      .catch((err: string) => {
        this.addUpdateAgreementState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateAgreementState.inProgress = false;
        })
      );
  };

  GetAgreementByIdService = (id: number) => {
    this.getAgreementByIdState.inProgress = true;
    let url = `${URLConstants.AgreementById}/${id}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.getAgreementByIdState.error = response.data.Message;
        } else {
          let data = response.data.Data;
          this.agreement = data;
        }
      })
      .catch((err: string) => {
        this.getAgreementByIdState.error = err;
      })
      .finally(
        action(() => {
          this.getAgreementByIdState.inProgress = false;
        })
      );
  };

  deleteAgreementService = (id: number) => {
    this.deleteAgreementState.inProgress = true;
    let url = `${URLConstants.DeleteAgreement}/${id}`;
    return baseService
      .deleteRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.deleteAgreementState.error = response.data.Message;
        } else {
          this.deleteAgreementState.success = true;
        }
      })
      .catch((err: string) => {
        this.deleteAgreementState.error = err;
      })
      .finally(
        action(() => {
          this.deleteAgreementState.inProgress = false;
        })
      );
  };

  setAgreementFilter = (filter: IAgreementFilter) => {
    this.agreementFilter = filter;
  };

  resetAgreementFilterDetail = () => {
    this.agreementFilter = { ...agreementInitialFilterState };
  };

  resetAgreementList = () => {
    this.getAllAgreementListState = { ...this.initialStateValue };
  };

  resetDeleteAgreement = () => {
    this.deleteAgreementState = { ...this.initialStateValue };
  };

  resetAddAgreement = () => {
    this.addUpdateAgreementState = { ...this.initialStateValue };
  };

  resetInitialValues = () => {
    this.initialValues = { ...initialAgreementValues };
  };
  resetGetAgreementDetail = () => {
    this.agreement = { ...initialAgreementValues };
    this.getAgreementByIdState = { ...this.initialStateValue };
  };

  get getAllAgreementList(): any {
    if (this.agreementList.AgreementVM.length > 0) {
      return this.agreementList.AgreementVM;
    } else {
      return [];
    }
  }

  get getAgreementDetail(): any {
    const userType = getUserTypeFromLocalStorage();
    const isHQorStore =
      userType === userTypeEnum[userTypeEnum.HeadQuarter] ||
      userType === userTypeEnum[userTypeEnum.Store];

    const businessTypeId = isHQorStore
      ? getBusinessTypeIdFromLocalStorage()
      : this.agreement?.BusinessTypeId ?? -1;

    if (this.agreement) {
      return {
        ...this.agreement,
        BusinessTypeId: businessTypeId,
        IsValid: this.agreement.IsValid ? "IsValid" : "IsNotValid",
      };
    }

    return {
      ...initialAgreementValues,
      BusinessTypeId: businessTypeId,
    };
  }

  get getAgreementFilter(): any {
    return this.agreementFilter;
  }

  /**
   * Adds a new store navigation password by calling the API with the provided password details.
   * Updates the MobX state based on the API response.
   *
   * @param data - The password details to be sent to the API for creation.
   * @returns A promise resolving with the API response.
   */
  AddAgreementPasswordService = (data: IUpdateAgreementPassword) => {
    this.changeAgreementPasswordState.inProgress = true;
    const url = URLConstants.MasterManagement + "/StoreNavigationSetting";
    return baseService
      .postRequest(url, data)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.changeAgreementPasswordState.error = response.data.Message;
        } else {
          this.changeAgreementPasswordState.success = true;
        }
      })
      .catch((err: any) => {
        this.changeAgreementPasswordState.error = err;
      })
      .finally(
        action(() => {
          this.changeAgreementPasswordState.inProgress = false;
        })
      );
  };

  /**
   * Updates the agreement user's password by calling the API with the provided password details.
   * Handles API response and updates the MobX state accordingly.
   *
   * @param data - The new password details to be sent to the API.
   * @returns A promise resolving with the API response.
   */
  UpdateAgreementPasswordService = (data: any) => {
    this.changeAgreementPasswordState.inProgress = true;
    const url = URLConstants.MasterManagement + "/StoreNavigationSetting";
    return baseService
      .putRequest(url, data)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.changeAgreementPasswordState.error = response.data.Message;
        } else this.changeAgreementPasswordState.success = true;
      })
      .catch((err: any) => {
        this.changeAgreementPasswordState.error = err;
      })
      .finally(
        action(() => {
          this.changeAgreementPasswordState.inProgress = false;
        })
      );
  };

  // function to get store navigation password by based on id
  GetAgreementPasswordByIdService = (id: number) => {
    this.changeAgreementPasswordState.inProgress = true;
    let url = `${URLConstants.MasterManagement}/StoreNavigationSetting/${id}`;
    return baseService
      .getRequest(url)
      .then(
        (
          response: IApiResponse<IApiSuccessResponse<IUpdateAgreementPassword>>
        ) => {
          if (response.data.Error) {
          this.disableAction = false;
        } else {
            this.disableAction = false;
            const data = response.data.Data;
            this.agreementPassword = data;
          }
        }
      )
      .catch((err: string) => {
        this.disableAction = true;
        this.changeAgreementPasswordState.error = err;
      })
      .finally(
        action(() => {
          this.changeAgreementPasswordState.inProgress = false;
        })
      );
  };

  get getAgreementPasswordDetail(): IUpdateAgreementPassword {
    return {
      Id: this.agreementPassword?.Id ?? 0,
      StoreId: this.agreementPassword?.StoreId ?? 0,
      Password: this.agreementPassword?.Password ?? "",
      ConfirmPassword: this.agreementPassword?.ConfirmPassword ?? "",
    };
  }


  resetChangePassword = () => {
    // this.changeAgreementPasswordState = { ...this.initialStateValue };
    this.agreementPassword = initialStateAgreementPassword;
  };

  setDisableAction = (acionStatus: boolean) =>{
    this.disableAction = acionStatus;
  }
}

export default new AgreementManagementStore();
